import { useState } from "react";
import { Button } from "../../../components/core/Button";
import { Modal } from "../../../components/others/Modal";
import LavorisService from "../../../services/LavorisService";
import Spinner from "../../../components/others/Spinner/Spinner";
import { SuccessModal } from "../../../components/others/SuccessModal";



type Tprops = {
    toggleModal?: boolean;
    urlTittle?: string;
    handleClose?: Function;
    email: string | null;
    username: string;
}

const PasswordExpirationAlert = ({ urlTittle, handleClose, email, username }: Tprops) => {
    const LavorisInstance = LavorisService.getInstance();
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [wspSuccesfullySent, setwspSuccesfullySent] = useState<boolean>(false);

    const sendValidationWsp = async () => {
        setIsLoading(true);
        try {
            const res: string = await LavorisInstance.Auth.sendValidationWsp(username);
            setPhoneNumber(res);
            setwspSuccesfullySent(true);
        } catch (error: any) {
            alert(error.response?.data?.message || "Error al enviar el mensaje");
            handleClose?.();
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            {!isLoading && !wspSuccesfullySent && email && (
                <Modal
                show
                urlTittle={urlTittle}
                onClose={() => handleClose && handleClose()}
            >
                <div className="w-full flex flex-col justify-between gap-2">
                        <h2 className="font-bold w-full flex justify-center text-xl">Tu contraseña ha caducado.</h2>
                        <span className="w-[350px] m-auto mb-3 text-center ">Se te envió un correo electrónico a "{email}" para que puedas crear una nueva.</span>
                        <div className="flex justify-center items-center gap-2 text-gray-600 mb-3">
                            <span>¿No te llegan los correos?</span>
                            <button
                                type="button"
                                className="text-gray-600 hover:text-blue-800 underline italic transition-colors cursor-pointer"
                                onClick={() => sendValidationWsp()}
                            >
                                Probar otro método
                            </button>
                        </div>
                        <div className="flex justify-center">
                            <Button
                                type="button"
                                text="Aceptar"
                                className="bg-red-500 font-bold text-white w-[auto] "
                                onClick={() => {
                                    handleClose?.();
                                }}
                            />
                        </div>
                    </div>
            </Modal>
            )}

            {email === null && (
                <Modal
                show
                urlTittle={urlTittle}
                onClose={() => handleClose && handleClose()}
            >
                <div className="w-full flex flex-col justify-between gap-2">
                        <h2 className="font-bold w-full flex justify-center text-xl">Tu contraseña ha caducado.</h2>
                        <span className="w-[350px] m-auto mb-3 text-center ">Al parecer no tienes un correo registrado, contáctate con recursos humanos.</span>
                        <div className="flex justify-center">
                            <Button
                                type="button"
                                text="Aceptar"
                                className="bg-red-500 font-bold text-white w-[auto] "
                                onClick={() => {
                                    handleClose?.();
                                }}
                            />
                        </div>
                    </div>
            </Modal>
            )}

            {isLoading && (
                <Modal 
                show={true}
                urlTittle={urlTittle}
                >
                    <Spinner/>
                </Modal>
            )}

            {!isLoading && wspSuccesfullySent && phoneNumber && (
                <SuccessModal 
                show
                modalTitle={"Listo"}
                modalSubtitle={`Se te envió un mensaje a ${phoneNumber}`}
                urlTittle={urlTittle}
                onClose={handleClose ? () => [handleClose(), setPhoneNumber(""), setwspSuccesfullySent(false)] : undefined}
                />
            )}
        </>
    )
}

export default PasswordExpirationAlert;